import { getLowCodePageMetrics } from '@carnica/landing-kit/utils';

import { headerStore2024 } from 'store';

export const lowCodePageMetrics = getLowCodePageMetrics(headerStore2024);

export * from '@carnica/landing-kit/utils';
